module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAABGdBTUEAALGPC/xhBQAAAHVJREFUKBWdjMsNgCAQRDnRA6XQED3REKXQAyd9Y+DgRlCZZNjfPJxbK3GWtxShWrf6XwqkKz661Wv3SZ5UwQMeVTvdXpVJDMhW3ZZKXC1kZ2UeFdk2bAE7K6PsTYGpYhuezcqKueR5C56FZ3sxYl3egMen+QRW40+x9l5h1AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/triangle_black_transparent_8_5.png
// module id = ./src/_asset/sources/assets/images/triangle_black_transparent_8_5.png
// module chunks = main